export const SCHEDULE_ROUTE = "/schedule";
export const MY_TASKS_ROUTE = "/my-tasks";
